import { render, staticRenderFns } from "./GlobalSearchBar.vue?vue&type=template&id=f4567b86"
import script from "./GlobalSearchBar.vue?vue&type=script&lang=js"
export * from "./GlobalSearchBar.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchBar.vue?vue&type=style&index=0&id=f4567b86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports